import * as yup from 'yup';

export const validationSchemaIcaro = yup.object().shape({
  dataDeclaration: yup.object().shape({
    reasonRefusal: yup.string().nullable().required('Campo obbligatorio'),
  }),
});

export const validationSchemaIcaroEmpty = yup.object().shape({});
